<template>
  <el-form
    :model="form"
    :rules="rules"
    ref="formRef"
    label-position="top"
    v-loading="loading"
  >
    <el-form-item label="Сообщение" prop="message">
      <el-input
        v-model="form.message"
        type="textarea"
        :autosize="{ minRows: 2 }"
      />
    </el-form-item>
    <el-form-item label="Прикрепленные файлы">
      <div style="display: flex; justify-content: space-between;">
        <el-upload
          ref="uploadRef"
          action="test"
          multiple
          :http-request="addFile"
          :on-remove="removeFile"
        >
          <el-button icon="el-icon-paperclip">
            Добавить файл
          </el-button>
        </el-upload>
        <div>
          <el-button type="primary" @click.stop="submit()">Отправить</el-button>
          <el-button @click.stop="handleClear">Отмена</el-button>
        </div>
      </div>
    </el-form-item>
  </el-form>
</template>
<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      loading: false,
      form: {
        message: "",
        files: []
      },
      rules: {
        message: [
          {
            required: true,
            message: "Введите сообщение",
            trigger: "blur"
          },
          {
            min: 3,
            max: 4000,
            message: "Введите не немее 3 но не более 4000 символов",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    ...mapActions(["sendComment"]),
    addFile(e) {
      this.form.files.push(e.file);
    },
    removeFile(e) {
      this.form.files = this.form.files.filter(item => item.name !== e.name);
    },
    handleClear() {
      this.$refs.formRef.resetFields();
      this.$refs.uploadRef.clearFiles();
      this.form = {
        message: "",
        files: []
      };
    },
    async sendComment() {
      try {
        this.loading = true;
        const formData = new FormData();
        formData.append("message", this.form.message);
        this.form.files.forEach(element => {
          formData.append("files", element);
        });
        await this.$store.dispatch("sendComment", {
          id: this.$route.params.id,
          comment: formData
        });
        this.handleClear();
        this.$emit("refresh");
      } catch (e) {
        this.error = this.$ErrorsMod(e);
      } finally {
        this.loading = false;
      }
    },
    submit() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          this.sendComment();
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style scoped>
::v-deep .el-form-item {
  margin-bottom: 10px;
}
::v-deep .el-form-item > label {
  padding: 0;
}
</style>
